import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Col, Container, Nav, Navbar, NavbarToggler, NavItem, Row } from 'reactstrap';

import ProfileDropdown from '#components/ProfileDropdown';
import { getLoggedInUser } from '#helpers/authUtils';
import { usePageTitle } from '#hooks/use-page-title.js';

import profilePic from '#assets/images/users/user-profile.png';

const profileMenus = [
    {
        label: 'My Account',
        icon: 'fas fa-user',
        redirectTo: '/account/my-account',
    },
    {
        label: 'Logout',
        icon: 'fas fa-sign-out-alt',
        redirectTo: '/account/logout',
    },
];

export default function Topbar({ navCssClasses = '', openLeftMenuCallBack }) {
    const title = usePageTitle();
    const { user } = useSelector((state) => state.Auth);
    const loggedInUser = getLoggedInUser();

    const handleLeftMenuToggle = useCallback(() => {
        openLeftMenuCallBack?.();
    }, [openLeftMenuCallBack]);

    return (
        <Navbar className={classNames('navbar-custom', navCssClasses)} expand="lg" fixed="top">
            <Container fluid>
                <Row className="w-100 align-items-center">
                    <Col xs="auto" className="d-flex align-items-center">
                        <NavbarToggler
                            className="button-menu-mobile d-lg-none"
                            aria-label="Toggle navigation menu"
                            onClick={handleLeftMenuToggle}
                        >
                            <i className="fas fa-bars" aria-hidden="true" />
                        </NavbarToggler>

                        <h3 className="center-title mb-0 ms-3">{title}</h3>
                    </Col>

                    <Col xs="auto" className="ms-auto">
                        <Nav className="topbar-right-menu" navbar>
                            {loggedInUser && user ? (
                                <NavItem className="notification-list">
                                    <ProfileDropdown
                                        profilePic={profilePic}
                                        menuItems={profileMenus}
                                        username={user?.name || loggedInUser?.name || 'User'}
                                        userTitle={user?.level?.label || loggedInUser?.level?.label || ''}
                                    />
                                </NavItem>
                            ) : null}
                        </Nav>
                    </Col>
                </Row>
            </Container>
        </Navbar>
    );
}
